import { AuthStorage } from "utils/auth-storage";
import React from "react";
import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { ActiveUsersService } from "apis/Services/ActiveUsersService";
import { ReportServices } from "apis/Services/ReportService";
import { saveReportAccessLevel } from "redux/permission-reducer";
import { useDispatch } from "react-redux";
import styles from "./reports.module.css";
import Container from "components/container";
import Text from "components/text";
import { Table } from "antd";
import LoadingComponent from "components/loading-component";
import { Link } from "react-router-dom";
import ProjectReports from "pages/project-reports";
import {
  CANNED_REPORTS,
  canAccessCannedReport,
  normalizeReportAccessLevel,
  parseCannedReportsGranularPermission,
} from "./reportPermissions";

export default function Report() {
  const { company_id, id } = useParams();
  const [isLoading, setisLoading] = useState(true);
  const [accessLevel, setAccessLevel] = useState(0);
  const [cannedReportsGranularPermission, setCannedReportsGranularPermission] =
    useState("");
  const [projectName, setProjectName] = useState("");
  const dispatch = useDispatch();

  const allowedReports = useMemo(
    () =>
      parseCannedReportsGranularPermission(cannedReportsGranularPermission),
    [cannedReportsGranularPermission],
  );
  const isGranularReportsUser = accessLevel > 0 && accessLevel < 2;

  useEffect(() => {
    setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      project: id,
      code,
      loginEmail: email,
    };
    ReportServices.getReportAccessLevel(ReqObj)
      .then((res) => {
        const nextAccessLevel = normalizeReportAccessLevel(res?.accessLevel);
        setAccessLevel(nextAccessLevel);
        setProjectName(res.projectName);
        setCannedReportsGranularPermission(
          res?.cannedReportsGranularPermission || "",
        );
        dispatch(saveReportAccessLevel(nextAccessLevel));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setisLoading(false));
  }, [company_id, dispatch, id]);

  const [ActiveUsers, setActiveUsers] = useState([]);
  const [ActiveUsersIcon, setActiveUsersIcon] = useState([]);

  const getActiveUsers = () => {
    let code = AuthStorage.getItem("token");
    let loginEmail = AuthStorage.getItem("email");
    let data = {
      company_id,
      loginEmail,
      code,
      project_id: id,
    };
    ActiveUsersService.getUsers(data)
      .then((res) => {
        // console.log(res, "ActiveUsers");
        setActiveUsers(res);
        setActiveUsersIcon(res);
      })
      .catch((err) => {
        // console.log(err);
      });
  };
  const addActiveUser = () => {
    let code = AuthStorage.getItem("token");
    let loginEmail = AuthStorage.getItem("email");
    let data = {
      company_id,
      loginEmail,
      code,
      project_id: id,
    };
    ActiveUsersService.AddUser(data)
      .then((res) => {})
      .catch((err) => {
        // console.log(err);
      })
      .finally(() => getActiveUsers());
  };
  const removeUser = () => {
    let code = AuthStorage.getItem("token");
    let loginEmail = AuthStorage.getItem("email");
    let data = {
      company_id,
      loginEmail,
      code,
      project_id: id,
    };
    ActiveUsersService.RemoveUser(data)
      .then((res) => {})
      .catch((err) => {
        // console.log(err);
      });
  };

  const visibleReports = useMemo(() => {
    if (!isGranularReportsUser) {
      return CANNED_REPORTS;
    }

    return CANNED_REPORTS.filter((report) =>
      canAccessCannedReport({
        accessLevel,
        allowedReports,
        reportName: report.name,
      }),
    );
  }, [accessLevel, allowedReports, isGranularReportsUser]);

  const dataSource = visibleReports.map((report) => ({
    key: report.key,
    Report: (
      <Link className={styles.linkStyle} to={report.slug}>
        {report.name}
      </Link>
    ),
    Description: report.description,
  }));

  const hasNoAssignedReports =
    isGranularReportsUser && visibleReports.length < 1;

  const columns = [
    {
      title: "Report",
      dataIndex: "Report",
      key: "Report",
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
    },
  ];

  return (
    <>
      <ProjectReports pageType="canned-reports" />
      {/* <div className=" d-flex flex-column gap-0 bg-white py-2 border border-1 border-top">
        <Text className=" fs-5 p-2">{projectName}</Text>
      </div> */}

      <Container className="mt-4">
        {isLoading && (
          <>
            <div className="row d-flex justify-content-center">
              <LoadingComponent />
            </div>
          </>
        )}

        {!isLoading && accessLevel === 0 && (
          <div className="row">
            <div className="text-center">
              <Text>
                You do not have the necessary permissions to access this page.
              </Text>
            </div>
          </div>
        )}
        {!isLoading && accessLevel > 0 && (
          <>
            <div className="row">
              <div className="col-md-12">
                <Text className={`${styles.header}`}>Canned Reports</Text>
              </div>
            </div>
            {hasNoAssignedReports ? (
              <div className="row mt-4">
                <div className="text-center">
                  <Text>
                    You are not assigned to view any canned reports.
                  </Text>
                </div>
              </div>
            ) : (
              <div className="row mt-4">
                <Table
                  dataSource={dataSource}
                  columns={columns}
                  pagination={false}
                  bordered
                  disabled
                />
              </div>
            )}
          </>
        )}
      </Container>
    </>
  );
}
